"use client";

import { DEVTOOLS_URL, IS_PRODUCTION, OVERRIDE_DEBUG } from "@/common/const";
import React, { useEffect, useState } from "react";
function DebugScript() {
  const [isDebug, setIsDebug] = useState(false);
  useEffect(() => {
    const isDebugLocal = localStorage.getItem("isDebug");
    console.log(isDebugLocal);
    setIsDebug(!!isDebugLocal);
  }, []);
  if (OVERRIDE_DEBUG || IS_PRODUCTION && isDebug) {
    return <script src={DEVTOOLS_URL} async />;
  }
  return null;
}
export default DebugScript;